export const GLOBAL_DISCLAIMER_STORE_WINDOW_KEY = '__ksysGlobalDisclaimerStore__';
export const GLOBAL_USER_COUNTRY_KEY = '__ksysUserCountry__';
export const KSYS_GLOBAL_VARIABLES_WINDOW_KEY = '__ksysGlobalVariables__';
export const CONTEXT_STORE_WINDOW_KEY = '__ksysContextStore__';
